var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"organization-logo-wrapper",class:{ dark: _vm.dark, bordered: _vm.bordered, backgrounded: _vm.backgrounded },style:({ 'background-color': _vm.backgroundColor })},[_c('img',{ref:"picture",staticClass:"organization-logo",attrs:{"crossorigin":"anonymouse","src":_vm.picture}})])
}
var staticRenderFns = []

export { render, staticRenderFns }